import React from "react";

import { useTranslation } from "react-i18next";

import TimeslotRuleItemRenderer from "./TimeslotRuleItemRenderer";
import DropzoneListContainer from "../../dropzoneList/DropzoneListContainer";

import type { JSX } from "react";

import type { TimeslotRule } from "../../../api/FastAPI.types";

interface TimeslotRuleListProps {
  ruleList: TimeslotRule[];
  onRuleListChange: (ruleList: TimeslotRule[]) => void;
  isLoading: boolean;
}

function TimeslotRuleList({
  ruleList,
  onRuleListChange,
  isLoading,
}: TimeslotRuleListProps): JSX.Element {
  const { t } = useTranslation("editor-fast-channel");
  return (
    <div className="bg-muted flex h-full flex-col">
      <DropzoneListContainer
        isFullSize
        classNamesContainer="py-3"
        initialItemList={ruleList}
        isLoading={isLoading}
        onChange={onRuleListChange}
        renderItem={TimeslotRuleItemRenderer}
        placeholder={{
          text: t("timeslotRuleListPlaceholder"),
          withIcon: true,
        }}
      />
    </div>
  );
}

export default TimeslotRuleList;
